import React from "react";

export const SmallHadding = (props) => {
  return (
    <h3 className={`${props.className}  font-medium font76 m-0` }  >{props.text}</h3>
  );
};
